<div class="row">
  <div class="col-md-12">
    <div class="form-group label-floating">
      <label class="control-label">Select view</label>
      <div class="btn-group">
        <label class="btn btn-raised" [ngClass]="{'active': displayDashboard==true}" (click)="displayDashboard = true">
          <input type="radio" autocomplete="off"> Dashboard
        </label>
        <label class="btn btn-raised" [ngClass]="{'active': displayDashboard==false}" (click)="displayDashboard = false">
          <input type="radio" autocomplete="off"> Calendar
        </label>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="form-group label-static">
      <label class="control-label" for="selectedUser">IT'z</label>
      <select id="selectedUser" name="selectedUser" class="form-control" [(ngModel)]="selectedUser">
        @for (user of users; track user) {
          <option [ngValue]="user">{{user.userFirstName}} {{user.userName}}</option>
        }
      </select>
    </div>
  </div>
</div>

@if (displayDashboard) {
  <div>
    <dashboard [selectedUser]="selectedUser" [displayedAsTab]="displayedAsTab"></dashboard>
  </div>
}

@if (displayDashboard==false) {
  <div>
    <calendarComponent [selectedUser]="selectedUser"></calendarComponent>
  </div>
}
